<template>
  <div class="vehicle-update">
    <wrld-container :breadcrumbs="this.breadcrumbs" :pageIsLoading="pageIsLoading">
      <v-form
        ref="vehicleForm"
        v-model="valid"
        lazy-validation
      >
        <VehicleForm v-model="vehicle"/>
        <v-btn class="mr-4" @click="goBack()">{{$t('buttons.cancel')}}</v-btn>
        <v-btn @click="callUpdateVehicle()" :disabled="!valid">{{$t('buttons.save')}}</v-btn>
        <span v-if="!valid" class="red--text">{{$t('general.not_all_required_fields')}}</span>
      </v-form>
    </wrld-container>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import router from '@/router'
import VehicleForm from '@/components/fleet/VehicleForm.vue'

export default {
  name: 'VehicleUpdate',
  components: { VehicleForm },
  data () {
    return {
      valid: true,
      vehicle: {
        overview: {
          name: '',
          licence_plate: '',
          is_internal: true,
          costs: {
            price_per_km: '',
            currency: 'EUR'
          }
          // allowed_countries: []
        },
        costs: {
          price_per_km: '',
          currency: 'EUR'
        },
        permissions: {
          allow: [],
          deny: []
        },
        properties: {
          vehicle_dimensions: { length: '', width: '', height: '' },
          vehicle_max_weight: '',
          case_dimensions: { length: '', width: '', height: '' },
          case_max_weight: '',
          roof_dimensions: { length: '', width: '', height: '' },
          roof_max_weight: '',
          trailer_dimensions: { length: '', width: '', height: '' },
          trailer_max_weight: ''
        }
      },
      countries: ['CZ', 'SK'],
      breadcrumbs: [
        { text: 'Wereldo', disabled: false, href: '#/' },
        { text: this.$i18n.t('fleet.vehicles'), disabled: false, href: '#/internal-fleet' }
      ],
      pageIsLoading: false
    }
  },
  computed: {
    ...mapState(['route', 'vehicles'])
  },
  created () {
    this.fetchData()
  },
  methods: {
    ...mapActions({
      createVehicle: 'createVehicle',
      updateVehicle: 'updateVehicle',
      fetchVehicles: 'fetchVehicles',
      showSnackbar: 'showSnackbar'
    }),
    async fetchData () {
      this.pageIsLoading = true
      let vehicleID = this.route.params.vehicleID
      if (vehicleID != null) {
        if (this.vehicles.data[vehicleID] == null) {
          await this.fetchVehicles()
        // await this.fetchVehicleByID(vehicleID)
        }
        await this.fillData(this.vehicles.data[vehicleID])
        this.breadcrumbs.push({ text: `${this.vehicle.overview.name}: ${this.$i18n.t('buttons.edit')}`, disabled: true })
      } else {
        this.breadcrumbs.push({ text: this.$i18n.t('buttons.create'), diabled: true })
      }
      this.pageIsLoading = false
    },

    goBack () {
      router.go(-1)
    },

    callUpdateVehicle () {
      if (this.$refs['vehicleForm'].validate()) {
        let vehicle = this.transformTmpVehicle()
        console.log(vehicle)
        let snackMsg = ''
        let snackColor = ''
        console.log(this.vehicle)
        if (this.vehicle.id === undefined) {
          this.createVehicle(vehicle)
          if (this.vehicles.error) {
            snackMsg = this.$i18n.t('snacbars.error')
            snackColor = 'errorr'
          } else {
            snackMsg = this.$i18n.t('snackbars.vehicle_created')
            snackColor = 'success'
          }
          this.showSnackbar({ message: snackMsg, color: snackColor })
          router.push({ name: 'InternalFleet' })
        } else {
          console.log('UPDATE')
          this.updateVehicle(vehicle)
          if (this.vehicles.error) {
            snackMsg = this.$i18n.t('snacbars.error')
            snackColor = 'errorr'
          } else {
            snackMsg = this.$i18n.t('snackbars.vehicle_updated')
            snackColor = 'success'
          }
          this.showSnackbar({ message: snackMsg, color: snackColor })
          router.push({ name: 'VehicleDetail', params: { vehicleID: this.vehicle.id } })
        }
      }
    },
    async fillData (veh) {
      let overview = {
        name: veh.name,
        licence_plate: veh.licence_plate,
        is_internal: veh.is_internal,
        costs: {
          price_per_km: veh.costs.price_per_km,
          currency: veh.costs.currency
        }
      }
      this.$set(this.vehicle, 'id', veh.id)
      this.$set(this.vehicle, 'overview', overview)
      this.$set(this.vehicle, 'properties', veh.properties)
    },
    transformTmpVehicle () {
      var obj = Object.assign({}, this.vehicle)
      obj.id = this.vehicle.id
      obj.name = this.vehicle.overview.name
      obj.licence_plate = this.vehicle.overview.licence_plate
      obj.is_internal = this.vehicle.overview.is_internal
      obj.allowed_countries = (this.vehicle.overview.allowed_countries ? this.vehicle.overview.allowed_countries : [])
      // obj.permissions = this.vehicle.permissions

      obj.costs.price_per_km = Number(this.vehicle.overview.costs.price_per_km)
      obj.properties.vehicle_dimensions.length = Number(this.vehicle.properties.vehicle_dimensions.length)
      obj.properties.vehicle_dimensions.width = Number(this.vehicle.properties.vehicle_dimensions.width)
      obj.properties.vehicle_dimensions.height = Number(this.vehicle.properties.vehicle_dimensions.height)
      obj.properties.vehicle_max_weight = Number(this.vehicle.properties.vehicle_max_weight)

      obj.properties.case_dimensions.length = Number(this.vehicle.properties.case_dimensions.length)
      obj.properties.case_dimensions.width = Number(this.vehicle.properties.case_dimensions.width)
      obj.properties.case_dimensions.height = Number(this.vehicle.properties.case_dimensions.height)
      obj.properties.case_max_weight = Number(this.vehicle.properties.case_max_weight)

      obj.properties.roof_dimensions.length = Number(this.vehicle.properties.roof_dimensions.length)
      obj.properties.roof_dimensions.width = Number(this.vehicle.properties.roof_dimensions.width)
      obj.properties.roof_dimensions.height = Number(this.vehicle.properties.roof_dimensions.height)
      obj.properties.roof_max_weight = Number(this.vehicle.properties.roof_max_weight)

      obj.properties.trailer_dimensions.length = Number(this.vehicle.properties.trailer_dimensions.length)
      obj.properties.trailer_dimensions.width = Number(this.vehicle.properties.trailer_dimensions.width)
      obj.properties.trailer_dimensions.height = Number(this.vehicle.properties.trailer_dimensions.height)
      obj.properties.trailer_max_weight = Number(this.vehicle.properties.trailer_max_weight)

      return obj
    }
  }
}
</script>
